import { object } from "prop-types";
import { useTranslation } from "react-i18next";
import { observer } from "mobx-react";
import { useEditorWebsocket } from "@hooks";
import {
  useEstimateEditorSettings,
  useEstimateEditorStore,
  ElementChatPopup,
  VisibilityButton, useEstimateStructure
} from "@tools";
import { TooltipIcon } from "@components";
import { Trash } from "@assets";

export const SummaryNestedRowActions = observer(({
  resource,
}) => {
  const { t } = useTranslation();
  const { visibilityMode } = useEstimateEditorStore();
  const structure = useEstimateStructure();
  const socket = useEditorWebsocket();
  const { allowEdition, showChatThread, useProfitability } = useEstimateEditorSettings();
  
  const { name, isHidden, treePath } = resource;
  const { isTimelineTableUsed } = structure.settings;

  const path = treePath.join("/");
  const timelinePath = "t" + path;
  
  
  const handleRemoval = async () => {
    resource.removeSelf();
    socket?.requestCommentPathRemove(path);
    socket?.requestCommentPathRemove(timelinePath);
  };
  
  return (
    <>
      {
        visibilityMode &&
        <VisibilityButton
          hidden={isHidden}
          onChange={resource.setIsHidden}
          inRow
        />
      }
      {
        showChatThread && !useProfitability &&
        <ElementChatPopup
          rowThread
          path={path}
          taskName={name || t("common.unnamed")}
        />
      }
      {
        allowEdition && !isTimelineTableUsed &&
        <TooltipIcon
          icon={<Trash color="error" />}
          onClick={handleRemoval}
          className="button-remove hoverIcon"
        >
          {t("views.editor.remove_resource")}
        </TooltipIcon>
      }
    </>
  );
});

SummaryNestedRowActions.propTypes = {
  resource: object,
};
